import client from "./client";

export const pitchmanApi = {
  // Every PitchMan download: { extension_url, firefox_url, mac_url,
  // windows_url }, each null while that download is not out yet.
  links: () => client.get("/api/pitchman/links"),
};
